import _ from 'lodash';
import moment from 'moment';

export const isClinicOpen = (hours) => {
  if (!hours || hours.length === 0) {
    return false;
  }
  const now = moment();
  const currentMinute = now.hour() * 60 + now.minutes();
  let weekday = now.isoWeekday();
  // our clinic hours are 0 indexed, while isoWeekday() returns Sunday as 7
  if (weekday === 7) {
    weekday = 0;
  }
  const closing = hours[weekday].end;
  return currentMinute < closing;
};

export const markFeaturesWithOffered = (clinicFeatures, allFeatures) => {
  const clinicFeaturesId = clinicFeatures.map((feature) => feature.id);
  allFeatures.forEach((feature) => {
    if (_.includes(clinicFeaturesId, feature.id)) {
      const featureOffered = feature;
      featureOffered.offered = true;
      return featureOffered;
    }
    return feature;
  });
  return allFeatures;
};
